<template>
  <nav class="community-clusters card mobile:radius-zero" aria-label="Темы блога">
    <p class="p-small uppercase fw-semi t-grey mn-b-regular">Темы</p>

    <ul class="flex flex-column gap-thin">
      <li>
        <router-link :to="{ name: 'Blog' }" :class="linkClass(null)">
          Все статьи
        </router-link>
      </li>
      <li v-for="cluster in clusters" :key="cluster.tag">
        <router-link :to="{ name: 'Blog', query: { tags: cluster.tag } }" :class="linkClass(cluster.tag)">
          {{ cluster.label }}
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

// Навигация по темам-кластерам (SEO_STRATEGY.md §5). Каждый пункт ведёт на
// tag-фильтрованную выдачу листинга (`?tags=<slug>` — Blog.vue прокидывает tags
// в Feed, бэкенд матчит `tags: { $in: [slug] }`). Это хаб внутренней
// перелинковки / topical authority для органики.
//
// Белая карточка с бордером+тенью (единая система рельс). Активный пункт —
// синий pill (на белом фоне белый pill был невидим). Цвета — палитрой.
const route = useRoute();

const clusters = [
  { tag: 'cover-letter', label: 'Сопроводительное письмо' },
  { tag: 'resume',       label: 'Резюме' },
  { tag: 'auto-apply',   label: 'Отклики и автоотклик' },
  { tag: 'job-search',   label: 'Поиск работы' },
  { tag: 'interview',    label: 'Собеседование' },
  { tag: 'salary',       label: 'Зарплаты' },
];

const activeTag = computed(() => route.query.tags || null);

const linkClass = (tag) => [
  'community-clusters__link p-small d-block radius-small pd-small cursor-pointer',
  activeTag.value === tag ? 'community-clusters__link--active fw-medium' : 't-grey',
];
</script>

<style scoped lang="scss">
.community-clusters {
  box-shadow: var(--elevation-1);
}

.community-clusters__link {
  transition: background 0.15s ease, color 0.15s ease;
}

// Активный пункт — синий pill (тинт + синий текст).
.community-clusters__link--active {
  background: rgba(var(--main), 0.1);
  color: rgb(var(--main));
}

.community-clusters__link:not(.community-clusters__link--active):hover {
  background: rgba(var(--main), 0.06);
  color: rgb(var(--black));
}
</style>
